import { GameContext } from '../../../contexts/GameContext';
import { ImageWrapper } from '../../common/wrappers/ImageWrapper';
import { ProfileContext } from '../../../contexts/ProfileContext';
import { useTime } from '../../../hooks/useTime';
import { useTimer } from '../../../hooks/useTimer';
import React, { useContext, useEffect } from 'react';
import ZdarProgressBar from './ZdarProgressBar';
import cat1 from '../../../assets/images/games/zdar-escape-game/cats/cat1.webp';
import cat2 from '../../../assets/images/games/zdar-escape-game/cats/cat2.webp';
import cat3 from '../../../assets/images/games/zdar-escape-game/cats/cat3.webp';
import cat4 from '../../../assets/images/games/zdar-escape-game/cats/cat4.webp';
import cat5 from '../../../assets/images/games/zdar-escape-game/cats/cat5.webp';
import cat6 from '../../../assets/images/games/zdar-escape-game/cats/cat6.webp';
import cat7 from '../../../assets/images/games/zdar-escape-game/cats/cat7.webp';
import cat8 from '../../../assets/images/games/zdar-escape-game/cats/cat8.webp';

type Props = {
    image?: number;
};

export default function ZdarStopWatch({ image }: Props) {
    const { availableGame } = useContext(ProfileContext);
    const { timer, isActive, handleStart, setTimer } = useTimer(0, availableGame?.started);
    const { currentStep } = useContext(GameContext);
    const { getTimeSplit } = useTime();

    const images = [null, cat1, cat2, cat3, cat4, cat5, cat6, cat7, cat8];

    useEffect(() => {
        if (availableGame?.started) {
            const current = Math.floor(new Date().getTime() / 1000);
            const started = parseInt(availableGame.started);
            setTimer(current - started);
        }
    }, []);

    const getImageSize = (i: number) => {
        if (i === 1) {
            return 40;
        }
        if (i === 8) {
            return 60;
        }
        return 50;
    };

    const formatTime = () => {
        const { getSeconds, getMinutes, getHours } = getTimeSplit(timer);
        return (
            <div className="stopwatch-wrapper-outside">
                <div className="stopwatch-content-wrapper">
                    <div className="stopwatch-image stopwatch-image--left">
                        {image && <ImageWrapper src={images[image]} alt="cat" width={getImageSize(image)} />}
                    </div>
                    <div className="stopwatch-time-wrapper">
                        <div>{'Celkový čas'}</div>
                        <div className="stopwatch-time-wrapper__bottom-row">
                            <div className="stopwatch-part">
                                <div>{getHours}</div>
                            </div>
                            <div className="stopwatch-delimiter">{':'}</div>
                            <div className="stopwatch-part">
                                <div>{getMinutes}</div>
                            </div>
                            <div className="stopwatch-delimiter">{':'}</div>
                            <div className="stopwatch-part">
                                <div>{getSeconds}</div>
                            </div>
                        </div>
                    </div>
                    <div className="stopwatch-image stopwatch-image--right">
                        {image && <ImageWrapper src={images[image]} alt="cat" width={getImageSize(image)} />}
                    </div>
                </div>
                <ZdarProgressBar />
            </div>
        );
    };

    useEffect(() => {
        if (!isActive) {
            handleStart();
        }
    }, [handleStart, isActive]);

    return (
        <React.Fragment>
            {currentStep < 37 && (
                <div className="stopwatch-wrapper">
                    <div className="card">{formatTime()}</div>
                </div>
            )}
        </React.Fragment>
    );
}
